import React from "react";
import { motion } from "framer-motion";
import { Typography, Divider } from "@mui/material"; // Import necessary MUI components
import AboutCardMatrix from "../AboutCardMatrix"; // Assuming this component exists for displaying text

const NoSlide = ({ data }) => {
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.8 } },
  };

  return (
    <motion.div
      style={{
        gridColumn: "3 / span 12",
        gridRow: "5 / span 14",
        padding: window.innerWidth < 1600 && window.innerHeight < 900 ? "0.5rem" : "2rem",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
      }}
      variants={fadeIn}
      initial="hidden"
      animate="visible"
    >
      <div style={{ flex: 1, marginRight: "1rem" }}>
        {/* Render icon */}
        <div className="text-gray-100 flex justify-center items-center">
          {data.icon}
        </div>

        {/* Render headline */}
        <Typography className="text-gray-100 text-center font-bold text-lg desktop1680:text-xl desktop1920:text-2xl desktop2560:text-3xl">
          {data.headline}
        </Typography>

        {/* Divider */}
        <Divider className="my-2 desktop1600:my-4 border-gray-600 mx-auto w-[80%] desktop2560:my-10" />

        {/* Render paragraphs */}
        {data.paragraphs && data.paragraphs.map((paragraph, index) => (
          <Typography
            key={index}
            className={`text-gray-100 text-center text-sm px-6 ${index === 0 ? "mb-4" : "hidden desktop1600:block"} desktop1920:text-lg`}
          >
            {paragraph}
          </Typography>
        ))}
      </div>

      <div style={{ flex: 2 }}>
        {/* Render the text using AboutCardMatrix */}
        <AboutCardMatrix texts={data.texts || []} speed={100} />
      </div>
    </motion.div>
  );
};

export default NoSlide;
